import React from 'react';

export const Cursor = ({ cur, hov, active }) => {
  if (!active) return null;

  return (
    <>
      <div className="cur-d" style={{ left: cur.x, top: cur.y }} />
      <div className={`cur-r${hov ? " h" : ""}`} style={{ left: cur.x, top: cur.y }} />
    </>
  );
};